import StyledTableHead from 'Components/StyledTableHead'
import type { PaytrailPaymentEventShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter } from 'Util/formatters'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const PaytrailPaymentEvents: FC<{
  events: PaytrailPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      {events.map(event => (
        <TableRow key={event.id}>
          <TableCell>{event.id}</TableCell>
          <TableCell>{datetimeFormatter(event.created)}</TableCell>
          <TableCell>{event.description}</TableCell>
        </TableRow>
      ))}
    </>
  )
}

const PaytrailPaymentInfo: FC<{
  events: PaytrailPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Paytrail)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableHead>
        <TableRow>
          <TableCell>{t`ID`}</TableCell>
          <TableCell>{t`Created`}</TableCell>
          <TableCell>{t`Description`}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length > 0 ? (
          <PaytrailPaymentEvents events={events} />
        ) : (
          <TableRow>
            <TableCell>{t`No payment events available`}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  )
}

export { PaytrailPaymentInfo }
